// import React from "react";
import "./EventOneWeek.scss";

const Week = () => {
  return (
    <div className="Week-events">
      <div className="container">
        <div className="Week_inner">
          <div className="section_header">
            <div className="left">
              <div className="icon-main">
                <div className="icon">
                  <span class="material-symbols-outlined">event</span>
                </div>
              </div>
              <div>
                <h2 className="title">Events</h2>
              </div>
            </div>
          </div>
          <div className="cards">
            <div className="cards_inside">
              <h4 className="Cards_head">Today</h4>
              <p className="card_para">Friday, 15 Sep</p>
            </div>
            <div className="cards_inside">
              <h4 className="Cards_head">Tomorrow</h4>
              <p className="card_para">Mon, 12 Aug</p>
            </div>
            <div className="cards_inside">
              <h4 className="Cards_head">Weekened</h4>
              <p className="card_para">Sat, 2 Oct</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Week;
